import * as Yup from "yup";

const registrationSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required").min(2).max(50),
  lastName: Yup.string().required("Last Name is required").min(2).max(50),
  email: Yup.string().email().required("Email is required"),
  organization: Yup.string().required("Organization is required").min(2).max(100),
  serialNumber: Yup.string()
    .notRequired()
    .min(26, "Serial Number must be between 26 and 32 characters long")
    .max(32, "Serial Number must be between 26 and 32 characters long")
});

const resetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Please provide a valid password")
    .matches(
      /^(?!.*[%^_{}~`<>]).*(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}/,
      /* eslint-disable-next-line */
      "Password must be 8-20 characters long, include at least one uppercase letter, one lowercase letter, one number, and one special character (!*'();:@&=+$,/?#[])."
    )
    .max(20),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Verify Password is required")
});

const passwordResetSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required")
});


const forgotPasswordInitialValues = { email: "" };
const passwordResetInitialValues = {
  password: "",
  confirmPassword: ""
};

const registerInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  organization: "",
  jobRole: "",
  serialNumber: ""
};

export {
  registrationSchema,
  resetPasswordSchema,
  passwordResetSchema,
  forgotPasswordInitialValues,
  passwordResetInitialValues,
  registerInitialValues
};
